import React, { useContext, useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getInsightSettings, updateInsightSettings } from '../../../store/ai2';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { addScriptStyle } from '../../../auth/styles';
import { PrescriptionInsightHistoryTable } from './PrescriptionInsightHistoryTable';
import { AppointmentInsightHistoryTable } from './AppointmentInsightHistoryTable';
import Swal from 'sweetalert2/dist/sweetalert2.js';

import 'sweetalert2/dist/sweetalert2.css';
import Form from 'react-bootstrap/Form';
import { UserContext } from '../../../Ai2App';
import AddMedicationModal from '../AddMedicationModal';
import { usePatientInsightSettings } from '../../../context';

import sIcon from '../../../assets/img/s.png';

const InsightSettings = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const access_token = searchParams.get('access_token');
  const dispatch = useDispatch();

  // all insightSettings and patient first name from store
  //const { first_name } = useSelector ( state => state.patientProfile );
  const { patientProfile } = useSelector((state) => state.patientProfile);
  let { insightSettings, isLoading } = useSelector(
    (state) => state.insightSettings,
  );

  const [loading, setLoading] = useState(isLoading);
  const [prescriptionInsightList, setPrescriptionInsightList] = useState([]);
  const [appointmentInsightList, setAppointmentInsightList] = useState([]);
  const [appointmentSettingsUpdated, setAppointmentSettings] = useState([]);
  const [medicationSettingsUpdated, setMedicationSettings] = useState([]);
  const [isDirty, setIsDirty] = useState(false);
  const { userState, setUserState } = useContext(UserContext);
  const [showAddPrescription, setShowAddPrescription] = useState(false);
  const { applyInsightSettings } = usePatientInsightSettings();

  const { clinicianProfileStatus, selectedTenancy } = useSelector(
    (state) => state.clinicianProfile,
  );
  useEffect(() => {
    if (clinicianProfileStatus) {
      dispatch(getInsightSettings(access_token, selectedTenancy.tenancy_id));
    }
  }, [access_token, clinicianProfileStatus, dispatch]);

  const setData = () => {
    // TODO iterate through medication_types and medication_settings and merge them together
    let pInsightList = [];
    const aInsightList = [];

    if (insightSettings.medication_settings) {
      for (let i = 0; i < insightSettings.medication_settings.length; i++) {
        pInsightList.push({
          mpp: insightSettings.medication_settings[i].medicinal_product_pack,
          ...insightSettings.medication_settings[i],
        });
      }

      for (let i = 0; i < insightSettings.medication_types.length; i++) {
        pInsightList.push({ ...insightSettings.medication_types[i] });
      }

      pInsightList = pInsightList.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.mpp_id === value.mpp_id),
      );

      for (let i = 0; i < pInsightList.length; i++) {
        pInsightList[i].settings = [];
        for (let j = 0; j < insightSettings.medication_settings.length; j++) {
          if (
            pInsightList[i].mpp_id ==
            insightSettings.medication_settings[j].mpp_id
          ) {
            pInsightList[i].settings.push(
              insightSettings.medication_settings[j],
            );
          } else if (
            pInsightList[i].pds_mpp_id ==
            insightSettings.medication_settings[j].mpp_id
          ) {
            pInsightList[i].settings.push(
              insightSettings.medication_settings[j],
            );
          }
        }
        pInsightList[i].settings = pInsightList[i].settings.reverse();

        pInsightList[i].prescriptionInsightOptions = [
          {
            labelKey: 'None',
            value: 'No insights needed',
          },
          {
            labelKey: 'Dosage-based',
            value: 'Dosage-based',
          },
          {
            labelKey: 'Monthly',
            value: 'Monthly pickup',
          },
          {
            labelKey: 'Quarterly',
            value: 'Quarterly pickup',
          },
          {
            labelKey: 'Yearly',
            value: 'Yearly pickup',
          },
        ];
        pInsightList[i].prescriptionFrequencyOptions = [
          {
            labelKey: 'per day',
            value: 'per day',
          },
          {
            labelKey: 'per week',
            value: 'per week',
          },
          {
            labelKey: 'per fortnight',
            value: 'per fortnight',
          },
          {
            labelKey: 'per month',
            value: 'per month',
          },
        ];

        pInsightList[i].prescriptionDosageQtyValue = 0;
        if (pInsightList[i].settings.length > 0) {
          const indexChangeInsight = pInsightList[
            i
          ].prescriptionInsightOptions.findIndex(
            (item) =>
              item.labelKey ===
              pInsightList[i].settings[0].settings.changeInsight,
          );
          pInsightList[i].prescriptionInsightOptions.forEach(
            (x) => delete x['isSelected'],
          );
          if (indexChangeInsight >= 0) {
            pInsightList[i].prescriptionInsightOptions[indexChangeInsight][
              'isSelected'
            ] = true;
          } else {
            pInsightList[i].prescriptionInsightOptions[0]['isSelected'] = true;
          }

          const indexFrequency = pInsightList[
            i
          ].prescriptionFrequencyOptions.findIndex(
            (item) =>
              item.labelKey ===
              pInsightList[i].settings[0].settings.dosageFrequency,
          );
          pInsightList[i].prescriptionFrequencyOptions.forEach(
            (x) => delete x['isSelected'],
          );
          if (indexFrequency >= 0) {
            pInsightList[i].prescriptionFrequencyOptions[indexFrequency][
              'isSelected'
            ] = true;
          } else {
            pInsightList[i].prescriptionFrequencyOptions[0]['isSelected'] =
              true;
          }

          pInsightList[i].prescriptionDosageQtyValue =
            pInsightList[i].settings[0].settings.dosageQty ?? 0;
        } else {
          pInsightList[i].prescriptionFrequencyOptions.forEach(
            (x) => delete x['isSelected'],
          );
          pInsightList[i].prescriptionInsightOptions[0]['isSelected'] = true;
          pInsightList[i].prescriptionFrequencyOptions[0]['isSelected'] = true;
        }
      }

      if (pInsightList.length != prescriptionInsightList.length) {
        setPrescriptionInsightList(pInsightList);
      }
    }

    if (insightSettings.appointment_types) {
      for (let i = 0; i < insightSettings.appointment_types.length; i++) {
        aInsightList.push({ ...insightSettings.appointment_types[i] });
      }

      for (let i = 0; i < aInsightList.length; i++) {
        aInsightList[i].settings = [];
        for (let j = 0; j < insightSettings.appointment_settings.length; j++) {
          if (
            aInsightList[i].mbs_taxonomy_id ==
            insightSettings.appointment_settings[j].mbs_taxonomy_id
          ) {
            aInsightList[i].settings.push(
              insightSettings.appointment_settings[j],
            );
          }
        }
        aInsightList[i].settings = aInsightList[i].settings.reverse();
        aInsightList[i].appointmentInsightOptions = [
          {
            labelKey: 'None',
            value: 'No insights needed',
          },
          {
            labelKey: 'Monthly',
            value: 'Monthly requirement',
          },
          {
            labelKey: 'Quarterly',
            value: 'Quarterly requirement',
          },
          {
            labelKey: 'Yearly',
            value: 'Yearly requirement',
          },
          {
            labelKey: 'Custom',
            value: 'Custom requirement',
          },
        ];
        aInsightList[i].appointmentFrequencyOptions = [
          {
            labelKey: 'days',
            value: 'Days',
          },
          {
            labelKey: 'weeks',
            value: 'Weeks',
          },
          {
            labelKey: 'months',
            value: 'Months',
          },
          {
            labelKey: 'years',
            value: 'Years',
          },
        ];
        aInsightList[i].appointmentQtyValue = 0;
        aInsightList[i].appointmentInsightOptions.forEach(
          (x) => delete x['isSelected'],
        );
        if (aInsightList[i].settings.length > 0) {
          const index = aInsightList[i].appointmentInsightOptions.findIndex(
            (item) =>
              item.labelKey ===
              aInsightList[i].settings[0].settings.changeInsight,
          );
          if (index >= 0) {
            aInsightList[i].appointmentInsightOptions[index]['isSelected'] =
              true;
          } else {
            aInsightList[i].appointmentInsightOptions[0]['isSelected'] = true;
          }
          const indexFrequency = aInsightList[
            i
          ].appointmentFrequencyOptions.findIndex(
            (item) =>
              item.labelKey === aInsightList[i].settings[0].settings.frequency,
          );
          aInsightList[i].appointmentFrequencyOptions.forEach(
            (x) => delete x['isSelected'],
          );
          if (indexFrequency >= 0) {
            aInsightList[i].appointmentFrequencyOptions[indexFrequency][
              'isSelected'
            ] = true;
          } else {
            aInsightList[i].appointmentFrequencyOptions[0]['isSelected'] = true;
          }
          aInsightList[i].appointmentQtyValue =
            aInsightList[i].settings[0].settings.qty ?? 0;
        } else {
          aInsightList[i].appointmentInsightOptions[0]['isSelected'] = true;
          aInsightList[i].appointmentFrequencyOptions.forEach(
            (x) => delete x['isSelected'],
          );
          aInsightList[i].appointmentFrequencyOptions[0]['isSelected'] = true;
        }
      }

      if (aInsightList.length != appointmentInsightList.length) {
        setAppointmentInsightList(aInsightList);
      }
    }

    if (loading) {
      setLoading(false);
    }
  };

  const handleChangeAppointment = ($event) => {
    const index = appointmentSettingsUpdated.findIndex(
      (item) => item.mbs_taxonomy_id === Number.parseInt($event.target.id),
    );
    if (index >= 0) {
      let settings = appointmentSettingsUpdated[index].settings;
      settings.changeInsight = $event.target.value;
      appointmentSettingsUpdated[index] = {
        mbs_taxonomy_id: parseInt($event.target.id),
        settings: settings,
      };
    } else {
      const item = appointmentInsightList.find(
        (item) => item.mbs_taxonomy_id === Number.parseInt($event.target.id),
      );
      let settings;
      if (item.settings.length > 0) {
        settings = { ...item.settings[0].settings };
      } else {
        settings = {
          frequency: 'days',
          qty: 0,
          changeInsight: 'None',
        };
      }
      settings.changeInsight = $event.target.value;
      appointmentSettingsUpdated.push({
        mbs_taxonomy_id: parseInt($event.target.id),
        settings: settings,
      });
    }

    const _tempList = appointmentInsightList;
    const i = appointmentInsightList.findIndex(
      (item) => item.mbs_taxonomy_id === Number.parseInt($event.target.id),
    );
    const indexChangeInsight = _tempList[i].appointmentInsightOptions.findIndex(
      (item) => item.labelKey === $event.target.value,
    );
    _tempList[i].appointmentInsightOptions.forEach(
      (x) => delete x['isSelected'],
    );
    if (indexChangeInsight >= 0) {
      _tempList[i].appointmentInsightOptions[indexChangeInsight]['isSelected'] =
        true;
    } else {
      _tempList[i].appointmentInsightOptions[0]['isSelected'] = true;
    }
    setAppointmentInsightList(_tempList);
    setIsDirty(true);
    userState.unsavedData = true;
    setUserState(userState);
    setLoading(true);
  };

  const handleChangeMedicationChangeInsight = ($event) => {
    const index = medicationSettingsUpdated.findIndex(
      (item) => item.mpp_id === $event.target.id,
    );
    if (index >= 0) {
      let settings = medicationSettingsUpdated[index].settings;
      settings.changeInsight = $event.target.value;
      medicationSettingsUpdated[index] = {
        mpp_id: $event.target.id,
        settings: settings,
      };
    } else {
      const item = prescriptionInsightList.find(
        (item) =>
          item.mpp_id === $event.target.id ||
          item.pds_mpp_id === $event.target.id,
      );
      let settings;
      if (item.settings.length > 0) {
        settings = { ...item.settings[0].settings };
        delete settings['changeReasons'];
        delete settings['dosageChange'];
      } else {
        settings = {
          dosageFrequency: 'per day',
          dosageQty: 0,
          changeInsight: 'None',
        };
      }
      settings.changeInsight = $event.target.value;

      medicationSettingsUpdated.push({
        mpp_id: $event.target.id,
        settings: settings,
      });
    }

    const _tempList = prescriptionInsightList;
    const i = prescriptionInsightList.findIndex(
      (item) => item.mpp_id === $event.target.id,
    );
    const indexChangeInsight = _tempList[
      i
    ].prescriptionInsightOptions.findIndex(
      (item) => item.labelKey === $event.target.value,
    );
    _tempList[i].prescriptionInsightOptions.forEach(
      (x) => delete x['isSelected'],
    );
    if (indexChangeInsight >= 0) {
      _tempList[i].prescriptionInsightOptions[indexChangeInsight][
        'isSelected'
      ] = true;
    } else {
      _tempList[i].prescriptionInsightOptions[0]['isSelected'] = true;
    }
    setPrescriptionInsightList(_tempList);
    setIsDirty(true);
    userState.unsavedData = true;
    setUserState(userState);
    setLoading(true);
  };

  const handleChangeMedicationChangeFrequency = ($event) => {
    const index = medicationSettingsUpdated.findIndex(
      (item) => item.mpp_id === $event.target.id,
    );
    if (index >= 0) {
      let settings = medicationSettingsUpdated[index].settings;
      settings.dosageFrequency = $event.target.value;

      let dosageChange = false;

      const item = prescriptionInsightList.find(
        (item) =>
          item.mpp_id === $event.target.id ||
          item.pds_mpp_id === $event.target.id,
      );
      if (item.settings.length > 0) {
        if (
          item.settings[0].settings?.dosageFrequency != settings.dosageFrequency
        ) {
          dosageChange = true;
        }
      } else {
        dosageChange = true;
      }
      settings.dosageChange = dosageChange;

      medicationSettingsUpdated[index] = {
        mpp_id: $event.target.id.toString(),
        settings: settings,
      };
    } else {
      const item = prescriptionInsightList.find(
        (item) =>
          item.mpp_id === $event.target.id ||
          item.pds_mpp_id === $event.target.id,
      );
      let settings;
      if (item.settings.length > 0) {
        settings = { ...item.settings[0].settings };
        delete settings['changeReasons'];
        delete settings['dosageChange'];
        settings.dosageChange = $event.target.value != settings.dosageFrequency;
      } else {
        settings = {
          dosageFrequency: 'per day',
          dosageQty: 0,
          changeInsight: 'None',
          dosageChange: true,
        };
      }
      settings.dosageFrequency = $event.target.value;

      medicationSettingsUpdated.push({
        mpp_id: $event.target.id,
        settings: settings,
      });
    }

    const _tempList = prescriptionInsightList;
    const i = prescriptionInsightList.findIndex(
      (item) => item.mpp_id === $event.target.id,
    );
    const indexChangeInsight = _tempList[
      i
    ].prescriptionFrequencyOptions.findIndex(
      (item) => item.labelKey === $event.target.value,
    );
    _tempList[i].prescriptionFrequencyOptions.forEach(
      (x) => delete x['isSelected'],
    );
    if (indexChangeInsight >= 0) {
      _tempList[i].prescriptionFrequencyOptions[indexChangeInsight][
        'isSelected'
      ] = true;
    } else {
      _tempList[i].prescriptionFrequencyOptions[0]['isSelected'] = true;
    }
    setPrescriptionInsightList(_tempList);
    setIsDirty(true);
    userState.unsavedData = true;
    setUserState(userState);
    setLoading(true);
  };

  const handleChangeAppointmentChangeFrequency = ($event) => {
    const index = appointmentSettingsUpdated.findIndex(
      (item) => item.mbs_taxonomy_id === parseInt($event.target.id),
    );
    if (index >= 0) {
      let settings = appointmentSettingsUpdated[index].settings;
      settings.frequency = $event.target.value;
      appointmentSettingsUpdated[index] = {
        mbs_taxonomy_id: parseInt($event.target.id),
        settings: settings,
      };
    } else {
      const item = appointmentInsightList.find(
        (item) => item.mbs_taxonomy_id === Number.parseInt($event.target.id),
      );
      let settings;
      if (item.settings.length > 0) {
        settings = { ...item.settings[0].settings };
      } else {
        settings = {
          frequency: 'days',
          qty: 0,
          changeInsight: 'None',
        };
      }
      if (settings.qty == null || settings.qty == '') {
        settings.qty = 0;
      }
      settings.frequency = $event.target.value;

      appointmentSettingsUpdated.push({
        mbs_taxonomy_id: parseInt($event.target.id),
        settings: settings,
      });
    }

    const _tempList = appointmentInsightList;
    const i = appointmentInsightList.findIndex(
      (item) => item.mbs_taxonomy_id === Number.parseInt($event.target.id),
    );
    const indexChangeInsight = _tempList[
      i
    ].appointmentFrequencyOptions.findIndex(
      (item) => item.labelKey === $event.target.value,
    );
    _tempList[i].appointmentFrequencyOptions.forEach(
      (x) => delete x['isSelected'],
    );
    if (indexChangeInsight >= 0) {
      _tempList[i].appointmentFrequencyOptions[indexChangeInsight][
        'isSelected'
      ] = true;
    } else {
      _tempList[i].appointmentFrequencyOptions[0]['isSelected'] = true;
    }
    setAppointmentInsightList(_tempList);
    setIsDirty(true);
    userState.unsavedData = true;
    setUserState(userState);
    setLoading(true);
  };

  const handleChangeMedicationChangeQty = (selectedOptions) => {
    //handle the changed map stuff
    const index = medicationSettingsUpdated.findIndex(
      (item) => item.mpp_id === selectedOptions.target.id,
    );
    if (index >= 0) {
      let settings = medicationSettingsUpdated[index].settings;
      settings.dosageQty = parseFloat(selectedOptions.target.value);

      let dosageChange = false;
      const item = prescriptionInsightList.find(
        (item) =>
          item.mpp_id === selectedOptions.target.id.toString() ||
          item.pds_mpp_id === selectedOptions.target.id.toString(),
      );
      if (item.settings.length > 0) {
        if (item.settings[0].settings?.dosageQty != settings.dosageQty) {
          dosageChange = true;
        }
      } else {
        dosageChange = true;
      }
      settings.dosageChange = dosageChange;

      medicationSettingsUpdated[index] = {
        mpp_id: selectedOptions.target.id.toString(),
        settings: settings,
      };
    } else {
      const item = prescriptionInsightList.find(
        (item) =>
          item.mpp_id === selectedOptions.target.id.toString() ||
          item.pds_mpp_id === selectedOptions.target.id.toString(),
      );
      let settings;
      if (item.settings.length > 0) {
        settings = { ...item.settings[0].settings };
        delete settings['changeReasons'];
        delete settings['dosageChange'];
        settings.dosageChange =
          selectedOptions.target.value != settings.dosageQty;
      } else {
        settings = {
          dosageFrequency: 'per day',
          dosageQty: 0,
          changeInsight: 'None',
          dosageChange: true,
        };
      }
      settings.dosageQty = selectedOptions.target.value;

      medicationSettingsUpdated.push({
        mpp_id: selectedOptions.target.id.toString(),
        settings: settings,
      });
    }

    // bound value to the 'controlled input'
    const i = prescriptionInsightList.findIndex(
      (item) => item.mpp_id === selectedOptions.target.id,
    );
    const _tempList = prescriptionInsightList;
    _tempList[i].prescriptionDosageQtyValue = selectedOptions.target.value;
    setPrescriptionInsightList(_tempList);
    setIsDirty(true);
    userState.unsavedData = true;
    setUserState(userState);
    setLoading(true);
  };

  const handleChangeAppointmentChangeQty = (selectedOptions) => {
    //handle the changed map stuff
    const index = appointmentSettingsUpdated.findIndex(
      (item) =>
        item.mbs_taxonomy_id === Number.parseInt(selectedOptions.target.id),
    );
    if (index >= 0) {
      let settings = appointmentSettingsUpdated[index].settings;
      settings.qty = parseFloat(selectedOptions.target.value);
      appointmentSettingsUpdated[index] = {
        mbs_taxonomy_id: Number.parseInt(selectedOptions.target.id),
        settings: settings,
      };
    } else {
      const item = appointmentInsightList.find(
        (item) =>
          item.mbs_taxonomy_id === Number.parseInt(selectedOptions.target.id),
      );
      let settings;
      if (item.settings.length > 0) {
        settings = { ...item.settings[0].settings };
      } else {
        settings = {
          frequency: 'days',
          qty: 0,
          changeInsight: 'None',
        };
      }
      if (settings.frequency == null || settings.frequency == '') {
        settings.frequency = 'days';
      }
      settings.qty = selectedOptions.target.value;

      appointmentSettingsUpdated.push({
        mbs_taxonomy_id: parseInt(selectedOptions.target.id),
        settings: settings,
      });
    }

    // bound value to the 'controlled input'
    const i = appointmentInsightList.findIndex(
      (item) =>
        item.mbs_taxonomy_id === Number.parseInt(selectedOptions.target.id),
    );
    const _tempList = appointmentInsightList;
    _tempList[i].appointmentQtyValue = selectedOptions.target.value;
    setAppointmentInsightList(_tempList);
    setIsDirty(true);
    userState.unsavedData = true;
    setUserState(userState);
    setLoading(true);
  };

  function titleCase(str) {
    if (str) {
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      return splitStr.join(' ');
    } else {
      return '';
    }
  }

  function refreshScreen() {
    setPrescriptionInsightList([]);
    setAppointmentInsightList([]);
    setData();
    setIsDirty(false);
    setUserState({ ...userState, unsavedData: false });
    setLoading(true);
  }

  setData();

  if (!loading) {
    return (
      <>
        <Container fluid>
          <div className="main-container">
            <Row>
              <Col xs={12} lg={4} xl={6}>
                <h1 className="heading1 mt-3">Insight settings</h1>
              </Col>
            </Row>
            <Row>
              <Col xs={9} lg={9}>
                <h2 className="heading2 mt-3">
                  <img src={sIcon} alt="Insight Settings" /> Prescription
                  insight settings
                </h2>
                <div className="txtInsightSettingsNote">
                  The following medication pick-up schedule is currently applied
                  to{' '}
                  {patientProfile.first_name
                    ? patientProfile.first_name + patientProfile.first_name !=
                        null && patientProfile.first_name?.endsWith('s')
                      ? patientProfile.first_name + "' "
                      : patientProfile.first_name + "'s "
                    : ''}
                  profile. If you believe missed medication does not need to be
                  insightged as often, you can change the settings here. Note:
                  Each time a new prescription is entered in PBS, this will
                  default back to standard settings. Settings may take up to 24
                  hours to update.
                </div>
              </Col>
              <Col xs={3} lg={3}>
                <div className="btnRefresh">
                  <button
                    style={addScriptStyle}
                    onClick={() => setShowAddPrescription(true)}
                  >
                    Add prescription
                  </button>
                </div>
              </Col>
            </Row>

            {prescriptionInsightList.map((item, i) => {
              function getMedSelectItems(prescriptionInsightOptions) {
                let options = [];
                for (let o of prescriptionInsightOptions) {
                  options.push(<option value={o.labelKey}>{o.value}</option>);
                }
                return options;
              }

              function getMedFreqSelectItems(prescriptionFrequencyOptions) {
                let options = [];
                for (let o of prescriptionFrequencyOptions) {
                  options.push(<option value={o.labelKey}>{o.value}</option>);
                }
                return options;
              }

              return (
                <Row className={'mt-4'} key={item.mpp_id ?? item.pds_mpp_id}>
                  <Col sm={3}>
                    <h3 className="heading3">
                      {item.mpp
                        ? item.mpp[0].toUpperCase() + item.mpp.substring(1)
                        : item.code_system_display_name
                          ? item.code_system_display_name[0].toUpperCase() +
                            item.code_system_display_name.substring(1)
                          : ''}
                    </h3>
                  </Col>
                  <Col sm={1}>
                    <Row>
                      <Col>
                        <span className="txtInsightSettingsSubheading">
                          Change Insight
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div className="divSelect">
                          <div className="mb-3  mt-2">
                            <Form.Select
                              className={'insightSelect'}
                              id={item.mpp_id ?? item.pds_mpp_id}
                              value={
                                item.prescriptionInsightOptions.find(
                                  (x) => x.isSelected,
                                )?.labelKey ??
                                item.prescriptionInsightOptions[0].labelKey
                              }
                              onChange={handleChangeMedicationChangeInsight}
                            >
                              {getMedSelectItems(
                                item.prescriptionInsightOptions,
                              )}
                            </Form.Select>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                  <Col sm={1}>
                    {(item.prescriptionInsightOptions.find((x) => x.isSelected)
                      ?.labelKey ??
                      item.prescriptionInsightOptions[0].labelKey) ===
                      'Dosage-based' && ( // Hides column if setting isn't "Dosage-based"
                      <>
                        <Row>
                          <Col>
                            <span className="txtInsightSettingsSubheading">
                              Dosage qty
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="mb-3 mt-2">
                              <input
                                type="number"
                                min="0"
                                className="dosageSelect"
                                name="dosageQuantityText"
                                value={item.prescriptionDosageQtyValue}
                                id={item.mpp_id ?? item.pds_mpp_id}
                                onChange={handleChangeMedicationChangeQty}
                              />
                            </div>
                          </Col>
                        </Row>
                      </>
                    )}
                  </Col>
                  <Col sm={1}>
                    {(item.prescriptionInsightOptions.find((x) => x.isSelected)
                      ?.labelKey ??
                      item.prescriptionInsightOptions[0].labelKey) ===
                      'Dosage-based' && ( // Hides column if setting isn't "Dosage-based"
                      <>
                        <Row>
                          <Col>
                            <span className="txtInsightSettingsSubheading">
                              frequency
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="divSelect">
                              <div className="mb-3  mt-2">
                                <Form.Select
                                  className={'freqSelect'}
                                  id={item.mpp_id ?? item.pds_mpp_id}
                                  value={
                                    item.prescriptionFrequencyOptions.find(
                                      (x) => x.isSelected,
                                    )?.labelKey ??
                                    item.prescriptionFrequencyOptions[0]
                                      .labelKey
                                  }
                                  onChange={
                                    handleChangeMedicationChangeFrequency
                                  }
                                >
                                  {getMedFreqSelectItems(
                                    item.prescriptionFrequencyOptions,
                                  )}
                                </Form.Select>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </>
                    )}
                  </Col>

                  <Col sm={5}>
                    <PrescriptionInsightHistoryTable
                      settings={item.settings}
                    ></PrescriptionInsightHistoryTable>
                  </Col>
                </Row>
              );
            })}

            {showAddPrescription && (
              <div>
                <AddMedicationModal
                  toChild={showAddPrescription}
                  sendToParent={setShowAddPrescription}
                  currentSettings={prescriptionInsightList}
                  apptSettings={appointmentInsightList}
                  accessToken={access_token}
                />
              </div>
            )}

            <hr
              style={{
                color: '#979797',
                height: 1,
                border: '1px dashed',
              }}
            />

            <Row>
              <Col xs={8} lg={8}>
                <h2 className="heading2 mt-3">
                  <img src={sIcon} alt="" /> Appointment insight settings
                </h2>
              </Col>
            </Row>

            {appointmentInsightList.map((item, i) => {
              function getApptInsightSelectItems(appointmentInsightOptions) {
                let options = [];
                for (let o of appointmentInsightOptions) {
                  options.push(<option value={o.labelKey}>{o.value}</option>);
                }
                return options;
              }

              function getApptFreqSelectItems(appointmentFrequencyOptions) {
                let options = [];
                for (let o of appointmentFrequencyOptions) {
                  options.push(<option value={o.labelKey}>{o.value}</option>);
                }
                return options;
              }

              return (
                <Row className={'mt-4'} key={item.mbs_taxonomy_id}>
                  <Col sm={3}>
                    <h3 className="heading3">
                      {item.description} - {titleCase(item.parent_description)}
                    </h3>
                  </Col>
                  <Col sm={1}>
                    <Row>
                      <Col>
                        <span className="txtInsightSettingsSubheading">
                          Change Insight
                        </span>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <div className="divSelect">
                          <div className="mb-3 mt-2">
                            <Form.Select
                              className={'apptInsightSelect'}
                              id={item.mbs_taxonomy_id}
                              value={
                                item.appointmentInsightOptions.find(
                                  (x) => x.isSelected,
                                )?.labelKey ??
                                item.appointmentInsightOptions[0].labelKey
                              }
                              onChange={handleChangeAppointment}
                            >
                              {getApptInsightSelectItems(
                                item.appointmentInsightOptions,
                              )}
                            </Form.Select>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={1}>
                    {(item.appointmentInsightOptions.find((x) => x.isSelected)
                      ?.labelKey ??
                      item.appointmentInsightOptions[0].labelKey) ===
                      'Custom' && ( // Hides column if setting isn't "Dosage-based"
                      <>
                        <Row>
                          <Col>
                            <span className="txtInsightSettingsSubheading">
                              Every
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="mb-3 mt-2">
                              <input
                                type="number"
                                min="0"
                                className="dosageSelect"
                                name="dosageQuantityText"
                                value={item.appointmentQtyValue}
                                id={item.mbs_taxonomy_id}
                                onChange={handleChangeAppointmentChangeQty}
                              />
                            </div>
                          </Col>
                        </Row>
                      </>
                    )}
                  </Col>
                  <Col sm={1}>
                    {(item.appointmentInsightOptions.find((x) => x.isSelected)
                      ?.labelKey ??
                      item.appointmentInsightOptions[0].labelKey) ===
                      'Custom' && ( // Hides column if setting isn't "Dosage-based"
                      <>
                        <Row>
                          <Col>
                            <span className="txtInsightSettingsSubheading">
                              &nbsp;
                            </span>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <div className="divSelect">
                              <div className="mb-3  mt-2">
                                <Form.Select
                                  className={'freqSelect'}
                                  id={item.mbs_taxonomy_id}
                                  value={
                                    item.appointmentFrequencyOptions.find(
                                      (x) => x.isSelected,
                                    )?.labelKey ??
                                    item.appointmentFrequencyOptions[0].labelKey
                                  }
                                  onChange={
                                    handleChangeAppointmentChangeFrequency
                                  }
                                >
                                  {getApptFreqSelectItems(
                                    item.appointmentFrequencyOptions,
                                  )}
                                </Form.Select>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </>
                    )}
                  </Col>

                  <Col sm={5}>
                    <AppointmentInsightHistoryTable
                      settings={item.settings}
                    ></AppointmentInsightHistoryTable>
                  </Col>
                </Row>
              );
            })}

            {isDirty ? <Dirty /> : null}
          </div>
        </Container>
      </>
    );
  } else {
    return <p>loading</p>;
  }

  function Dirty() {
    return (
      <div className="fixed">
        <Row className="mt-4">
          <Col sm={9}></Col>
          <Col sm={3}>
            <Row>
              <Col>
                <button
                  type="button"
                  className="btn btnSecondary btn-xlong btn-xs ms-auto"
                  onClick={async (event) => {
                    event.target.disabled = true;
                    Swal.fire({
                      icon: 'info',
                      text: 'Changes have been cancelled.',
                      showConfirmButton: true,
                    });

                    setAppointmentSettings([]);
                    setMedicationSettings([]);

                    dispatch(
                      getInsightSettings(
                        access_token,
                        selectedTenancy.tenancy_id,
                      ),
                    ).then(() => {
                      refreshScreen();
                      event.target.disabled = false;
                    });
                  }}

                  //onClick={ onResetForm }
                >
                  Cancel changes
                </button>
              </Col>
              <Col>
                <button
                  type="submit"
                  className="btn btnPrimary btn-xs btn-xlong"
                  onClick={(event) => {
                    event.target.disabled = true;
                    if (
                      medicationSettingsUpdated.length > 0 ||
                      appointmentSettingsUpdated.length > 0
                    ) {
                      Swal.fire({
                        icon: 'success',
                        text: 'Changes have been saved.',
                        showConfirmButton: true,
                      });

                      applyInsightSettings({
                        medication_settings: medicationSettingsUpdated,
                        appointment_settings: appointmentSettingsUpdated,
                      }).then(() => {
                        setAppointmentSettings([]);
                        setMedicationSettings([]);

                        dispatch(
                          getInsightSettings(
                            access_token,
                            selectedTenancy.tenancy_id,
                          ),
                        ).then((x) => {
                          refreshScreen();
                          event.target.disabled = false;
                        });
                      });
                    } else {
                      Swal.fire({
                        icon: 'info',
                        text: 'No changes have been made.',
                        showConfirmButton: true,
                      });
                      event.target.disabled = false;
                    }
                  }}
                >
                  Save changes
                </button>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
};

export { InsightSettings };
